module.exports = __webpack_public_path__ + "static/media/Anvay_Joshi.fc8d7cfd.jpg";